import * as React from 'react';
import { Component } from 'react';
import styles from '../../styles/flyouts/my_company_members/PrivateDetails.scss';
import * as _ from 'lodash';
import { withRouter } from 'react-router';
import autobind from 'autobind-decorator';
import { __, mapStateToProps, validateForm } from '../../core/utils';
import { setNotification } from '../../redux/actions/general/notification';
import { updateCompanyMemberDetails } from '../../redux/actions/table/my_company_members';
import classNames from 'classnames';
import Localization from '../../helpers/Localization';
import { subscribe } from 'react-contextual/dist/react-contextual.es';
import PrivateDetailsForm from '../../forms/my_company_members/PrivateDetailsForm';
import moment from 'moment';

@withRouter
@mapStateToProps((state) => ({
  table: state.table['my_company_members'],
  auth: state.auth,
}))
@subscribe(Localization, 'localization')
class PrivateDetails extends Component {
  @autobind
  _handleSubmit(formData) {
    const {
      flyout: { compensation },
    } = this.props.table;

    formData = {
      ...formData,
      date_of_birth: formData.date_of_birth
        ? moment(formData.date_of_birth, 'DD.MM.YYYY').format('YYYY-MM-DD')
        : null,
    };

    return validateForm(
      updateCompanyMemberDetails(formData).then(() => {
        this.props.readAction();
        setNotification(__('my-company-members.properties.saved'));
      })
    );
  }

  render() {
    const { data, collapsed, localization } = this.props;

    return (
      <div
        className={classNames(styles.wrapper, collapsed && styles.collapsed)}
      >
        <PrivateDetailsForm
          onSubmit={this._handleSubmit}
          data={data}
          localization={localization}
          initialValues={{
            user_id: data.details.id,

            personal_identification_number:
              data.private_details?.personal_identification_number,
            // date_of_birth: data.private_details?.date_of_birth,
            date_of_birth: data.private_details?.date_of_birth
              ? moment(data.private_details.date_of_birth).format('DD.MM.YYYY')
              : null,
            city_of_birth: data.private_details?.city_of_birth,
            country_of_birth_id: data.private_details?.country_of_birth_id,

            resident_country_id: data.private_details?.resident_country_id,
            postal_code: data.private_details?.postal_code,
            city: data.private_details?.city,
            address_1: data.private_details?.address_1,
            address_2: data.private_details?.address_2,
            personal_mobile: data.private_details?.personal_mobile,
            personal_phone: data.private_details?.personal_phone,
            personal_email: data.private_details?.personal_email,

            tax_number: data.private_details?.tax_number,
            iban: data.private_details?.iban,
            health_insurance: data.private_details?.health_insurance,
            pension_insurance: data.private_details?.pension_insurance,
            voluntary_insurance: data.private_details?.voluntary_insurance,

            education_country_id: data.private_details?.education_country_id,
            education_city: data.private_details?.education_city,
            schools: data.private_details?.schools,
            education_level: data.private_details?.education_level,

            comment: data.private_details?.comment,
          }}
        />
      </div>
    );
  }
}

export default PrivateDetails;
